class PopUpPilihEntity {
  popupTitle: string;
  tableContent: Array<any>;
  onClick: ((row: any) => void);
  onClose: (() => void);

  constructor(object: { popupTitle: string, tableContent: Array<any>, onClick: ((row: any) => void), onClose: (() => void) }) {
      this.popupTitle = object.popupTitle;
      this.tableContent = object.tableContent;
      this.onClick = object.onClick;
      this.onClose = object.onClose;
  }
}

export { PopUpPilihEntity };
